<template>
  <TheLoader class="loader" v-if="loading"></TheLoader>
  <div v-else>
    <h1 class="title">
      <template v-if="basket.type === 'Bestelling'">{{ $t('order') }}</template>
      <template v-else>{{ $t('quote') }}</template>
      <span v-if="this.isAdmin" style="color: red"> [ADMIN]</span></h1>
    <div class="step-details">
      <h3>{{ $t('contactForm.title') }}</h3>
      <span class="line"/>
      <span class="step">{{ $t('step') }} {{ getTotalSteps() }}</span>
    </div>

    <ErrorBox v-if="form.errors && Object.keys(form.errors).length > 0 && !form.firstVisit"
              :errors="form.errors"></ErrorBox>

    <div class="blocks">
      <div class="block-steps">
        <span class="step">{{ $t('step') }} {{ getTotalSteps() }}</span>
        <span class="line-vertical"/>
      </div>
      <div class="block-form">
        <h3 class="desktop">{{ $t('contactForm.title') }}</h3>

        <TextInput @change="updateInputValue('companyName', $event.value)" :inputValue="form.companyName"
                   labelFor="companyName" :labelText="$t('contactForm.companyName')"
                   :show-error="!form.firstVisit" :error-text="form.errors?.companyName"
                   :max-length="form.modelLengths?.companyName" required
        ></TextInput>

        <SelectInput @change="updateInputValue('country', $event.value)"
                     :options="countrySelect" :select-value="form.country"
                     :label-text="$t('country')" label-for="country"
                     :show-error="!form.firstVisit" :error-text="form.errors?.country"
                     required
        ></SelectInput>

        <SelectInput v-if="isAdmin"
                     @change="updateInputValue('locale', $event.value)"
                     :options="langSelect" :select-value="form.locale"
                     :label-text="`${$t('contactForm.language')} [ADMIN]`" label-for="locale"
                     :show-error="!form.firstVisit" :error-text="form.errors?.locale"
                     required
        ></SelectInput>

        <TextInput @change="updateInputValue('vatNumber', $event.value)" :inputValue="form.vatNumber"
                   labelFor="vatNumber" :labelText="$t('contactForm.vatNumber')"
                   :show-error="!form.firstVisit" :error-text="form.errors?.vatNumber"
                   :max-length="form.modelLengths?.vatNumber"
        ></TextInput>

        <template v-if="form.reversedAddress">
          <div class="double-input">
            <TextInput @change="updateInputValue('houseNumber', $event.value)" :inputValue="form.houseNumber"
                       labelFor="houseNumber" :labelText="$t('houseNumber')"
                       :show-error="!form.firstVisit" :error-text="form.errors?.houseNumber"
                       :max-length="form.modelLengths?.houseNumber"
            ></TextInput>
            <TextInput @change="updateInputValue('extension', $event.value)" :inputValue="form.extension"
                       labelFor="extension" :labelText="$t('extension')"
                       :show-error="!form.firstVisit" :error-text="form.errors?.extension"
                       :max-length="form.modelLengths?.extension"
            ></TextInput>
          </div>
            <TextInput @change="updateInputValue('streetName', $event.value)" :inputValue="form.streetName"
                       labelFor="streetName" :labelText="$t('streetName')"
                       :show-error="!form.firstVisit" :error-text="form.errors?.streetName"
                       :max-length="form.modelLengths?.streetName" required
            ></TextInput>
        </template>
        <template v-else>
          <TextInput @change="updateInputValue('streetName', $event.value)" :inputValue="form.streetName"
                     labelFor="streetName" :labelText="$t('streetName')"
                     :show-error="!form.firstVisit" :error-text="form.errors?.streetName"
                     :max-length="form.modelLengths?.streetName" required
          ></TextInput>
          <div class="double-input">
            <TextInput @change="updateInputValue('houseNumber', $event.value)" :inputValue="form.houseNumber"
                       labelFor="houseNumber" :labelText="$t('houseNumber')"
                       :show-error="!form.firstVisit" :error-text="form.errors?.houseNumber"
                       :max-length="form.modelLengths?.houseNumber"
            ></TextInput>
            <TextInput @change="updateInputValue('extension', $event.value)" :inputValue="form.extension"
                       labelFor="extension" :labelText="$t('extension')"
                       :show-error="!form.firstVisit" :error-text="form.errors?.extension"
                       :max-length="form.modelLengths?.extension"
            ></TextInput>
          </div>
        </template>

        <TextInput @change="updateInputValue('zipcode', $event.value)" :inputValue="form.zipcode"
                   labelFor="zipcode" :labelText="$t('zipcode')"
                   :show-error="!form.firstVisit" :error-text="form.errors?.zipcode"
                   :max-length="form.modelLengths?.zipcode" required
        ></TextInput>

        <TextInput @change="updateInputValue('city', $event.value)" :inputValue="form.city"
                   labelFor="city" :labelText="$t('city')"
                   :show-error="!form.firstVisit" :error-text="form.errors?.city"
                   :max-length="form.modelLengths?.city" required
        ></TextInput>

        <SelectInput @change="updateInputValue('salutation', $event.value)"
                     :select-value="form.salutation"
                     :label-text="$t('contactForm.salutation')" label-for="salutation"
                     :show-error="!form.firstVisit" :error-text="form.errors?.salutation">
          <template v-slot:extraOptions>
            <option value="M">{{ $t('contactForm.sexM') }}</option>
            <option value="V">{{ $t('contactForm.sexF') }}</option>
          </template>
        </SelectInput>

        <TextInput @change="updateInputValue('contactName', $event.value)" :inputValue="form.contactName"
                   labelFor="contactName" :labelText="$t('contactName')"
                   :show-error="!form.firstVisit" :error-text="form.errors?.contactName"
                   :max-length="form.modelLengths?.contactName" required
        ></TextInput>

        <TextInput @change="updateInputValue('contactPhone', $event.value)" :inputValue="form.contactPhone"
                   labelFor="contactPhone" :labelText="$t('contactPhone')"
                   :show-error="!form.firstVisit" :error-text="form.errors?.contactPhone"
                   :max-length="form.modelLengths?.contactPhone" required
        ></TextInput>

        <TextInput @change="updateInputValue('contactCellphone', $event.value)" :inputValue="form.contactCellphone"
                   labelFor="contactCellphone" :labelText="$t('contactCellphone')"
                   :show-error="!form.firstVisit" :error-text="form.errors?.contactCellphone"
                   :max-length="form.modelLengths?.contactCellphone"
        ></TextInput>

        <TextInput @change="updateInputValue('email', $event.value)" :inputValue="form.email"
                   labelFor="email" :labelText="$t('email')"
                   :show-error="!form.firstVisit" :error-text="form.errors?.email"
                   :max-length="form.modelLengths?.email" required
        ></TextInput>

        <TextInput @change="updateInputValue('reference', $event.value)" :inputValue="form.reference"
                   labelFor="reference" :labelText="$t('contactForm.reference')"
                   :show-error="!form.firstVisit" :error-text="form.errors?.reference"
                   :max-length="form.modelLengths?.reference"
        ></TextInput>

        <CheckboxInput @change="updateInputValue('sameInvoiceMail', $event.value)" :inputValue="form.sameInvoiceMail"
                       labelFor="sameInvoiceMail" :labelText="$t('contactForm.sameInvoiceMail')"
        ></CheckboxInput>

        <TextInput v-if="!form.sameInvoiceMail"
                   @change="updateInputValue('invoiceTnv', $event.value)" :inputValue="form.invoiceTnv"
                   labelFor="invoiceTnv" :labelText="$t('contactForm.invoiceTnv')"
                   :show-error="!form.firstVisit" :error-text="form.errors?.invoiceTnv"
                   :max-length="form.modelLengths?.invoiceTnv"
        ></TextInput>

        <TextInput v-if="!form.sameInvoiceMail"
                   @change="updateInputValue('invoiceMail', $event.value)" :inputValue="form.invoiceMail"
                   labelFor="invoiceMail" :labelText="$t('contactForm.invoiceMail')"
                   :show-error="!form.firstVisit" :error-text="form.errors?.invoiceMail"
                   :max-length="form.modelLengths?.invoiceMail"
        ></TextInput>

        <CheckboxInput v-if="basket.type === 'Bestelling'"
                       @change="updateInputValue('createAccount', $event.value)" :inputValue="form.createAccount"
                       labelFor="createAccount" :labelText="$t('contactForm.confirmCreateAccount')"
        ></CheckboxInput>

        <BasketSummary v-if="basket.isCustom" :type="basket.type" :custom-rows="basket.customRows"
                       :valuta="basket.valuta" :total-excl="basket.customExcl" :total-incl="basket.customIncl"
                       :vat-percentage="basket.vatPercentage" :total-vat="basket.customVat"></BasketSummary>
        <BasketSummary v-else :type="basket.type" :products="basket.products" :total-excl="basket.totalExcl"
                       :total-excl-benb="basket.totalExclNoShipping"
                       :vat-percentage="basket.vatPercentage"
                       :total-vat="basket.totalVat" :kwantum-korting-excl="basket.kwantumKortingExcl"
                       :total-vat-benb="basket.totalVatNoShipping"
                       :dealer-row="basket.dealerRow" :dealer-amount="basket.dealerAmount"
                       :totalIncl="basket.totalIncl" :shipping-costs="basket.shippingCostsExcl"
                       :total-incl-benb="basket.totalInclNoShipping"
                       :benb-only="basket.benbOnly"></BasketSummary>

        <span v-if="form.deliverInTransportArea">
          {{ $t('contactForm.deliveryInTransportArea') }}
        </span>

        <div class="error-notification" v-if="form.errors && Object.keys(form.errors).length > 0 && !form.firstVisit">
          <span>
          {{ $t('errorTitle') }}
          </span>
        </div>

        <div class="nav-btns">
          <button :disabled="disableNextStep" @click="nextStep()" class="gsd-btn gsd-btn-secondary">
            {{ $t('contactForm.toDelivery') }}
          </button>
          <router-link @click="updateForm()" class="gsd-btn gsd-btn-tertiary mobile" :to="{ name: 'basket' }">
            <svg xmlns="http://www.w3.org/2000/svg" height="1.2em" viewBox="0 0 512 512" fill="currentcolor">
              <path
                  d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 288 480 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-370.7 0 73.4-73.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-128 128z"/>
            </svg>
            {{ $t('back') }}
          </router-link>
        </div>
      </div>

      <div class="block-right">
        <BasketSummary v-if="basket.isCustom" :type="basket.type" :custom-rows="basket.customRows"
                       :valuta="basket.valuta" :total-excl="basket.customExcl" :total-incl="basket.customIncl"
                       :vat-percentage="basket.vatPercentage" :total-vat="basket.customVat"
                       :is-pickup="hasPptMove"></BasketSummary>
        <BasketSummary v-else :type="basket.type" :products="basket.products" :total-excl="basket.totalExcl"
                       :total-excl-benb="basket.totalExclNoShipping"
                       :vat-percentage="basket.vatPercentage"
                       :total-vat="basket.totalVat" :kwantum-korting-excl="basket.kwantumKortingExcl"
                       :total-vat-benb="basket.totalVatNoShipping"
                       :dealer-row="basket.dealerRow" :dealer-amount="basket.dealerAmount"
                       :totalIncl="basket.totalIncl" :shipping-costs="basket.shippingCostsExcl"
                       :total-incl-benb="basket.totalInclNoShipping"
                       :is-pickup="hasPptMove" :benb-only="basket.benbOnly"></BasketSummary>
      </div>
    </div>
  </div>

</template>

<script>
import axios from 'axios';
import ErrorBox from "../components/ErrorBox.vue";
import BasketSummary from "../components/BasketSummary.vue";
import TextInput from "../components/form/TextInput.vue";
import SelectInput from "../components/form/SelectInput.vue";
import CheckboxInput from "../components/form/CheckboxInput.vue";
import TheLoader from "../components/general/TheLoader.vue";

export default {
  name: "ContactDetails",
  components: {TheLoader, CheckboxInput, SelectInput, TextInput, BasketSummary, ErrorBox},
  data() {
    return {
      public: public_dir, //deze mag niet hetzelfde heten, anders pikt ie t niet in de productie build
      loading: true,
      form: {},
      basket: {},
      isAdmin: false,
      hasPptMove: false,
      disableNextStep: false,
      step: 1,
      totalSteps: 3,
      langSelect: [],
      countrySelect: [],
      updateInputValueTimeout: null,
    };
  },
  async mounted() {
    this.loading = true;
    try {
      await this.getBasket();
      await this.getForm();
      await this.getSelectData();
    } catch (e) {
      this.$handleError(e);
    } finally {
      this.loading = false;
    }

  },
  methods: {
    async updateInputValue(fieldName, fieldValue) {
      this.form[fieldName] = fieldValue;
      await this.updateForm();

      // basket has been recalculated
      if (fieldName === 'vatNumber') await this.getBasket();
    },
    async getBasket() {
      try {
        const response = await axios.get(`/${this.$sessionLang}/api/getbasket`);

        this.basket = response.data.data.basket;
        this.hasPptMove = response.data.data.hasPptMove;
      } catch (error) {
        this.$handleError(error);
      }
    },
    async getForm() {
      try {
        const response = await axios.post(`/${this.$sessionLang}/api/getform`, {
          step: 'contact',
        });

        if (!response.data.data.hasProducts) {
          this.$router.push({name: 'basket'});
          return;
        }

        this.form = response.data.data.form;
        this.isAdmin = response.data.data.isAdmin;
        this.disableNextStep = (!this.form.firstVisit && this.hasErrors());
      } catch (error) {
        this.$handleError(error);
      }
    },
    async getSelectData() {
      try {
        const response = await axios.post(`/${this.$sessionLang}/api/getselectdata`, {
          lang: this.$sessionLang,
        });

        this.langSelect = response.data.data.langSelect;
        this.countrySelect = response.data.data.countrySelect;

      } catch (error) {
        this.$handleError(error);
      }
    },
    async updateForm() {

      try {
        const response = await axios.post(`/${this.$sessionLang}/api/updateform`, {
          form: this.form,
          step: 'contact',
        })

        await this.getForm();
      } catch (error) {
        this.$handleError(error);
      }
    },
    hasErrors() {
      let hasErrors = false;
      if (this.form.errors && Object.keys(this.form.errors).length > 0) {
        hasErrors = true;
      }

      return hasErrors;
    },
    getTotalSteps() {
      let totalSteps = 3;
      if (this.hasPptMove) {
        totalSteps = 4;
      }

      return this.step + '/' + totalSteps;
    },
    async nextStep() {
      this.form.firstVisit = false;
      await this.updateForm();

      if (!this.hasErrors()) {
        this.$router.push({name: 'delivery-details'});
      }
      else {
        this.disableNextStep = true;
      }
    },
  },
}
</script>

<style scoped>
.title {
  margin-bottom: 1em;
}

h3 {
  font: var(--bold-22-28);
}

.step-details {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
}

.line {
  background-color: var(--light-brown);
  height: 2px;
  border: none;
  opacity: 0.6;
  flex-grow: 1;
}

.step {
  font: var(--bold-10);
  color: var(--white);
  background-color: var(--black);
  padding: 5px;
  border-radius: 16px;
  text-align: center;
}

.double-input {
  display: flex;
  gap: 15px;
}

.double-input .form-input:not(.input-small) {
  width: 100%;
}

.form-input.checkbox input {
  max-width: 20px;
  max-height: 20px;
  color: #C9C9CC;
  accent-color: var(--brown);
}

.gsd-btn {
  width: 100%;
  font: var(--bold-16-20);
}

.gsd-btn-secondary {
  margin: 20px 0;
}

a.gsd-btn {
  border: none;
  display: flex;
  justify-content: center;
  gap: 5px;
  padding: 0;
}

a.gsd-btn:hover:not(:disabled) {
  background-color: inherit;
  border: inherit;
  text-decoration: none;
  color: var(--orange);
}

.error-notification {
  color: red;
  text-decoration: underline;
  margin: 15px 0;
}

.desktop,
.block-steps,
.block-right {
  display: none;
}

@media (min-width: 1140px) {
  .title {
    font: var(--bold-40-52);
  }

  h3 {
    font: var(--bold-32);
  }

  .step-details {
    display: none;
  }

  .blocks {
    display: flex;
    gap: 32px;
  }

  .block-steps {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 55px;
    gap: 8px;
  }

  .line-vertical {
    background-color: var(--light-brown);
    width: 2px;
    border: none;
    opacity: 0.6;
    flex-grow: 1;
  }

  .block-form {
    flex-grow: 1;
  }

  .block-form > h3 {
    margin-bottom: 24px;
  }

  .block-form .summary {
    display: none;
  }

  .summary {
    margin-top: 0;
  }

  .desktop,
  .block-right {
    display: inline-block;
  }

  .block-right {
    min-width: 440px;
    position: sticky;
    top: 90px;
    margin-left: auto;
    align-self: flex-start;
  }

  .nav-btns {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    justify-content: space-between;
  }

  .nav-btns .gsd-btn {
    width: auto;
    margin: 20px 0 0 0;
  }

}

</style>